import { usePendingUpdate } from "./pendingUpdate.ts";

/**
 * Small red dot shown only while a new app version is waiting to be taken
 * (in-game parity).
 *
 * Positioned by the caller (absolute; pass the offsets and a ring colour that
 * matches the surface it sits on). Rendered nowhere when nothing is pending,
 * so headers pay nothing for it the rest of the time.
 */
export const PendingUpdateDot = ({ className = "" }: { className?: string }) => {
  const pending = usePendingUpdate();
  if (!pending) return null;
  return (
    <span
      data-testid="pending-update-dot"
      // Decorative: the prompt and the drawer item carry the meaning for
      // screen readers.
      aria-hidden="true"
      className={`pointer-events-none absolute h-2.5 w-2.5 rounded-full bg-red-500 ${className}`}
    />
  );
};
